import { ISelectOption, Select } from '@salecycle/ui-component-library';
import * as React from 'react';
import { connect } from 'react-redux';

import { UserLoggedIn } from 'entities/campaign';
import { Actions } from 'sections/campaigns/state/rulesets';
import { OwnProps, Props } from './props';

export type FormProps = Props<UserLoggedIn>;

export const Form: React.FC<FormProps> = props => {
  const items = [
    { value: true, label: 'User is logged in' },
    { value: false, label: 'User is not logged in' },
  ];

  const update = (item: ISelectOption<boolean>) => {
    props.update(props.rulesetId, props.ruleIndex, { loggedIn: item.value });
  };

  const value =
    props.rule && props.rule.loggedIn !== null
      ? items.filter(item => item.value === props.rule.loggedIn).reduce((acc, item) => item, null)
      : null;

  return (
    <div data-testid="UserLoggedIn">
      <Select<boolean>
        ariaLabel="Login Status"
        label="Login Status"
        inputId="LoginStatusSelect"
        options={items}
        value={value}
        onChange={update}
      />
    </div>
  );
};

export default connect<{}, {}, OwnProps>(null, { update: Actions.editRule })(Form);
